import React, { Component } from 'react';
import AppContainer from '../../components/shared/app-container';
import { UserCreateApp } from './components/user-create-app';

class UserCreate extends Component {

    constructor(props) {

        super(props);
        this.state = {};
    }

    render() {
        return (
            <AppContainer application={<UserCreateApp />} />
        );
    }
}

export default UserCreate;
